import { sepolia } from "viem/chains";

export const SUPPORTED_NETWORK = [sepolia];
